import Swiper, {Pagination} from "swiper";
import SwiperCore, {FreeMode, Lazy,Manipulation} from "swiper";
import OverflowSlider from "./overflow-slider";
import VideoHls from "../components/video-hls";
import VideoPlayer from "../components/video-player";

SwiperCore.use([Pagination]);

class WatchSlider {

    loading = false;
    instance: Swiper;
    private interval = [];

    constructor() {
        this.instance = new Swiper('.watch-broadcast__slider', {
            slidesPerView: 'auto',
            updateOnWindowResize: true,
            loop: true,
            pagination: {
                el: ".watch-broadcast__pagination",
                clickable: true,
                bulletActiveClass: "watch-pagination-bullet_active",
                renderBullet: (index, className) => {
                    return `<div class="watch-pagination-bullet ${className}"></div>`;
                }
            },
            navigation: {
                nextEl: '.watch-broadcast__slider .btn-next',
                prevEl: '.watch-broadcast__slider .btn-prev',
                hiddenClass: 'd-none',
                disabledClass: 'd-none',
            },
            on: {
                init: swiper => {
                    this.onSlideChange(swiper)
                },
                slideChangeTransitionEnd: swiper => {
                    this.onSlideChange(swiper)
                }
            },
            autoplay:false,
            lazy: false,
            centeredSlides: true,
            //speed: 140,
            spaceBetween: 12,
            breakpoints: {
                1350: {
                    spaceBetween: 21,
                }
            }
        });
    }

    onSlideChange(swiper) {
        /*    const urlParams = new URLSearchParams(window.location.search);
        const tm = Number( urlParams.get('tm') ? urlParams.get('tm') : 15000);
        */

        if (this.interval.length) {
            this.interval.forEach(i => {
                clearTimeout(i)
            })

            this.interval = [];
        }

        let previousSlide = document.querySelectorAll('.watch-broadcast__wrapper');

        Array.from(previousSlide).forEach((e:HTMLElement) => {
            e.classList.remove('loaded');
            if (e.querySelector('.plyr'))
                e.querySelector('.plyr').remove();
            if (e.querySelector('.youtube-player'))
                e.querySelector('.youtube-player').remove();
        })

        let currentElement = swiper.slides[swiper.activeIndex]
        let currentSlide = currentElement.querySelector('.watch-broadcast__wrapper');
        if (currentSlide) {
            new VideoHls(currentSlide, {
                loop: false,
                onPlayStart: (videoHls) => {
                    let startTime = typeof currentSlide.dataset.videoStart !== 'undefined' ? currentSlide.dataset.videoStart : 0;

                    if (startTime)
                        videoHls.player.forward(startTime)

                    this.interval.push(setTimeout(() => {
                        swiper.slideNext();
                    }, 15000))

                },
                onEnded: () => {
                    swiper.slideNext();
                }
            });

        }
    }

}

export default WatchSlider;
